import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute, { AdvisorRoute } from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Landing from "@/pages/Landing";
import CalculatorsPage from "@/pages/CalculatorsPage";
import CalculatorDetailPage from "@/pages/CalculatorDetailPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Assets from "@/pages/Assets";
import Insurance from "@/pages/Insurance";
import Liabilities from "@/pages/Liabilities";
import Projections from "@/pages/Projections";
import Goals from "@/pages/Goals";
import Assumptions from "@/pages/Assumptions";
import FamilyVault from "@/pages/FamilyVault";
import Settings from "@/pages/Settings";
import { Pricing } from "./pages/Pricing";
import Admin from "./pages/Admin";
import ResetPassword from "./pages/ResetPassword";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Teerms";
import Security from "./pages/Security";
import VerifyEmail from "./pages/VerifyEmail";
import Support from "./pages/Support";
import Landing_Copy from "./pages/Landing_copy";
import DeleteAccount from "./pages/DeleteAccount";
import Taxation from "@/pages/Taxation";
import Scenarios from "@/pages/Scenarios";
import Documents from "@/pages/Documents";
import FamilySharing from "@/pages/FamilySharing";
import Insights from "@/pages/Insights";
import BulkAdd from "@/pages/BulkAdd";
import DemoLauncher from "@/pages/DemoLauncher";
import AdvisorDashboard from "@/pages/AdvisorDashboard";
import AdvisorWorkspace from "@/pages/AdvisorWorkspace";
import AdvisorMessages from "@/pages/AdvisorMessages";
import AdvisorApprovals from "@/pages/AdvisorApprovals";
import AdvisorProfile from "@/pages/AdvisorProfile";
import AccessManagement from "@/pages/AccessManagement";
import NotificationsPage from "@/pages/NotificationsPage";
import AdvisorDetail from "@/pages/AdvisorDetail";
import Guide from "./pages/Guide";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/demo/:persona" element={<DemoLauncher />} />
              <Route path="/calculators" element={<CalculatorsPage />} />
              <Route
                path="/calculators/:slug"
                element={<CalculatorDetailPage />}
              />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/account_deletion" element={<DeleteAccount />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/security" element={<Security />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/insights"
                element={
                  <ProtectedRoute>
                    <Insights />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/assets"
                element={
                  <ProtectedRoute>
                    <Assets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/bulk-add/:entity"
                element={
                  <ProtectedRoute>
                    <BulkAdd />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/liabilities"
                element={
                  <ProtectedRoute>
                    <Liabilities />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/insurance"
                element={
                  <ProtectedRoute>
                    <Insurance />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/projections"
                element={
                  <ProtectedRoute>
                    <Projections />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/goals"
                element={
                  <ProtectedRoute>
                    <Goals />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/assumptions"
                element={
                  <ProtectedRoute>
                    <Assumptions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/family-vault"
                element={
                  <ProtectedRoute>
                    <FamilyVault />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/taxation"
                element={
                  <ProtectedRoute>
                    <Taxation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/scenarios"
                element={
                  <ProtectedRoute>
                    <Scenarios />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/documents"
                element={
                  <ProtectedRoute>
                    <Documents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/family-sharing"
                element={
                  <ProtectedRoute>
                    <FamilySharing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/access"
                element={
                  <ProtectedRoute>
                    <AccessManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/notifications"
                element={
                  <ProtectedRoute>
                    <NotificationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/access/:connId"
                element={
                  <ProtectedRoute>
                    <AdvisorDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/advisor"
                element={
                  <AdvisorRoute>
                    <AdvisorDashboard />
                  </AdvisorRoute>
                }
              />
              <Route
                path="/advisor/workspace"
                element={
                  <AdvisorRoute>
                    <AdvisorWorkspace />
                  </AdvisorRoute>
                }
              />
              <Route
                path="/advisor/messages"
                element={
                  <AdvisorRoute>
                    <AdvisorMessages />
                  </AdvisorRoute>
                }
              />
              <Route
                path="/advisor/approvals"
                element={
                  <AdvisorRoute>
                    <AdvisorApprovals />
                  </AdvisorRoute>
                }
              />
              <Route
                path="/advisor/profile"
                element={
                  <AdvisorRoute>
                    <AdvisorProfile />
                  </AdvisorRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/support"
                element={
                  <ProtectedRoute>
                    <Support />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/guide"
                element={
                  <ProtectedRoute>
                    <Guide />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster closeButton position="top-right" />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
